import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { userCards } from "../../actions/cards/cards";
import { reportsCount, userReports } from "../../actions/reports/reports";
import { amountFormat } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import "./dashboard.css";
import TopSec from "./TopSec";
import moment from "moment";

const Dashboard = () => {
  const history = useHistory()
  const userCardResponse = useSelector((state) => state.cards.userCards?.data?.response?.cards?.filter(ele => !ele.card_reference_no?.includes("GFT"))?.[0] || {});
  const reports_count = useSelector((state) => state.cards.reports_count?.data?.response?.dashboard || {});
  const dispatch = useDispatch()
  const [reportStatus, setReportStatus] = useState("unsubmitted")
  const reportsResponse = useSelector((state) => state.reports.userReports || {});

  useEffect(() => {
    // dispatch(dashboard());
    dispatch(reportsCount());
    dispatch(userCards({}));
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    dispatch(userReports({
      status: reportStatus
    }))
    // eslint-disable-next-line
  }, [reportStatus])

  const columns = [
    {
      title: "Report Details",
      dataIndex: "report_id",
      key: "report_id",
      render: (text, record) => {
        return (
          <div className="report-title">
            <span className="d-block">{record?.number}</span>
            <span>
                {record?.from_date
                  ? moment(record.from_date).format("DD-MM-YYYY, HH:mm:ss")
                  : "-"}{" "}
                -{" "}
                {record?.to_date
                  ? moment(record.to_date).format("DD-MM-YYYY, HH:mm:ss")
                  : "-"}
            </span>
          </div>
        );
      },
    },
    {
      title: "Total",
      dataIndex: "total_amount",
      key: "total_amount",
      render: (text) => <div><BaseCurrency /> {amountFormat(text)}</div>,
    },
    {
      title: "To be reimbursed",
      dataIndex: "total_reimbursed_amount",
      key: "total_reimbursed_amount",
      render: (text) => <div><BaseCurrency /> {amountFormat(text)}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <div>
          <div className={`status status_${text}`}>{text.replace(/_/g, " ")}</div>
           <div>
            {record?.created_at
              ? moment(record.created_at).format("DD-MM-YYYY, HH:mm:ss")
              : "-"}
          </div>
        </div>
      ),
    },
  ];


  return (
    <div className="dashboard">
      <div className="head">
        <h2>
          Dashboard
          <span>Overview of Account</span>
        </h2>
        {/* <span className="active-text">Getting Started</span> */}
      </div>
      <TopSec card={userCardResponse} />
      <div className="card mt2 report-summary">
        <h2 className="p1">Reports Summary</h2>
        <div className="d-flex">
          <div className={`cursor ${reportStatus === "unsubmitted" ? "active" : ""}`} onClick={() => {
            setReportStatus("unsubmitted")
          }}>
            <span>Unsubmitted Reports</span>
            <span>
              <strong>{reports_count?.unreported_reports?.count}</strong>
              Reports
            </span>
          </div>
          <div className={`cursor ${reportStatus === "pending_approval" ? "active" : ""}`} onClick={() => {
            setReportStatus("pending_approval")
          }}>
            <span>Pending Approval</span>
            <span>
              <strong>{reports_count?.pending_approval_emp_count}</strong>
              Reports
            </span>
          </div>
          <div className={`cursor ${reportStatus === "pending_reimbursement" ? "active" : ""}`} onClick={() => {
            setReportStatus("pending_reimbursement")
          }} >
            <span>Pending Reimbursement</span>
            <span>
              <strong>{reports_count?.reports_pending_reimbursement
                ?.count}</strong>
              Reports
            </span>
          </div>
        </div>
      </div>
      <div className="report-table paycraft-table mt2">
        <Table columns={columns} dataSource={reportsResponse?.data?.response?.reports?.slice(0, 5)} pagination={false} />
        <span className="active-text cursor ml1" onClick={() => {
          history.push("/reports", {
            status: reportStatus
          })
        }}>View All</span>
      </div>
    </div>
  );
};

export default Dashboard;
